import { typedHttp } from '../http';
import { type RequestBody } from '../http/type-helpers';

import {
  APPLE_CREDENTIALS_ENDPOINT,
  APPLE_LOGIN_ENDPOINT,
  EBAY_AUTHORIZE_ENDPOINT,
  EBAY_USER_CREDENTIALS_ENDPOINT,
  EBAY_LOGIN_ENDPOINT,
  LOGIN,
} from '@/constants/endpoints';

export function login(credentials: RequestBody<typeof LOGIN>) {
  return typedHttp.post(LOGIN, credentials, {
    withDeviceId: true,
  });
}

export function loginWithApple(
  appleCredentials: RequestBody<typeof APPLE_LOGIN_ENDPOINT>
) {
  const { apple_user_id, apple_access_token } = appleCredentials;
  return typedHttp.post(
    APPLE_LOGIN_ENDPOINT,
    { apple_user_id, apple_access_token },
    {
      withDeviceId: true,
    }
  );
}

export function fetchAppleCredentials(appleCredentialRequest: {
  code: string;
  redirect_uri: string;
}) {
  return typedHttp.post(APPLE_CREDENTIALS_ENDPOINT, appleCredentialRequest);
}

export function fetchEbayAuthorizationUrl(state: string) {
  return typedHttp.get(EBAY_AUTHORIZE_ENDPOINT, { params: { state } });
}

export function fetchEbayUserCredentials(code: string) {
  return typedHttp.post(EBAY_USER_CREDENTIALS_ENDPOINT, { code });
}

export function loginWithEbay(
  ebayCredentials: Omit<RequestBody<typeof EBAY_LOGIN_ENDPOINT>, 'client_id'>
) {
  const { ebay_user_id, ebay_token_reference } = ebayCredentials;
  return typedHttp.post(
    EBAY_LOGIN_ENDPOINT,
    {
      client_id: process.env.NEXT_PUBLIC_OAUTH_CLIENT_ID ?? '',
      ebay_user_id,
      ebay_token_reference,
    },
    {
      withDeviceId: true,
    }
  );
}
